import ResourceHttp from '@/services/http/resources/authPassportHttp';
// import tokenServices from '@/services/util/token';
import { toastResponseError } from '@/services/util/alertService';

const app = {
  namespaced: true,
  state: {
    authUser: null,
    modalFormAlterPassword: false,
  },
  mutations: {
    AUTHUSER(state, data) {
      state.authUser = data;
    },
    TOGGLE_FORM_PASSWORD(state) {
      state.modalFormAlterPassword = !state.modalFormAlterPassword;
    },
  },
  actions: {
    me({ commit }) {
      return new Promise((resolve, reject) => {
        ResourceHttp.me()
          .then((response) => {
            commit('AUTHUSER', response.data.data);
            resolve(response);
          })
          .catch((error) => {
            toastResponseError(error);
            reject(error);
          });
      });
    },
    logout() {
      return new Promise((resolve, reject) => {
        ResourceHttp.logout()
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            toastResponseError(error);
            reject(error);
          });
      });
    },
    toggleFormPassord(context) {
      context.commit('TOGGLE_FORM_PASSWORD');
    },
    updatePassword({ commit }, data) {
      return new Promise((resolve, reject) => {
        ResourceHttp.update(data, data.id)
          .then((response) => {
            commit('TOGGLE_FORM_PASSWORD');
            resolve(response);
          })
          .catch((error) => {
            toastResponseError(error);
            reject(error);
          });
      });
    },
  },
};

export default app;
